import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 全局变量
var global = {
  namespaced: true, //需要开启命名空间
  actions: {},
  mutations: {
    CONFIG(state, value) {
      
    },
    //系统基本信息
    SYSTEM(state, value) {
      state.system = value
    },
    //网络链接监听
    ONLINE(state, value) {
      state.online = value
    },
    //打印机列表
    PRINTERS(state, value) {
      console.log('打印机刷新列表：',value)
      state.printers = value
    },
    //打印机本地配置信息
    PRINTERSERVE(state, value) {
      state.printerServe = value
      localStorage.printerServe = JSON.stringify(value)
    }
  },
  state: {
    system: {}, 
    online: true,
    printers: [],
    printerServe: {},
  },
  getters: {

  }
}

// 用户信息
var userinfo = {
  namespaced: true,
  actions: {},
  mutations: {
    USERINFO(state, value){
      state.userinfo = value
    },
    USERAVATAR(state, value) {
      state.userinfo.avatar = value
    }
  },
  state:{
    userinfo: {
      avatar: ""
    }
  },
  getters: {}
}

// 状态
var status = {
  namespaced: true,
  actions: {},
  mutations: {
    ISLOGIN(state, value) { //登录状态
      state.isLogin = value
    }
  },
  state:{
    isLogin: false, //账号登录状态
  },
  getters: {}
}


export default new Vuex.Store({
  modules:{
    userinfo,
    status,
    global
  }
})
